import { render, staticRenderFns } from "./AccountMenuBtn.vue?vue&type=template&id=ab7ac742"
import script from "./AccountMenuBtn.vue?vue&type=script&lang=ts"
export * from "./AccountMenuBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports